import { EXTERNAL_LINKS } from '@enter/business-components/lib/external-links';

type FooterProductLabelKey =
    | 'products.enterCode'
    | 'products.enterCli'
    | 'products.framia'
    | 'products.combos'
    | 'products.anycap';

type FooterProductInternalLink = {
    slug: string;
    type: 'internal';
    path: string;
    labelKey: FooterProductLabelKey;
};

type FooterProductExternalLink = {
    slug: string;
    type: 'external';
    href: string;
    labelKey: FooterProductLabelKey;
};

export type FooterProductLink = FooterProductInternalLink | FooterProductExternalLink;

export const FOOTER_PRODUCT_LINKS: readonly FooterProductLink[] = [
    { slug: 'enter-code', type: 'internal', path: '/code', labelKey: 'products.enterCode' },
    { slug: 'enter-cli', type: 'internal', path: '/cli', labelKey: 'products.enterCli' },
    { slug: 'framia', type: 'external', href: EXTERNAL_LINKS.FRAMIA, labelKey: 'products.framia' },
    { slug: 'combos', type: 'external', href: EXTERNAL_LINKS.COMBOS, labelKey: 'products.combos' },
    { slug: 'anycap', type: 'external', href: EXTERNAL_LINKS.ANYCAP, labelKey: 'products.anycap' },
] as const;
